import { render, staticRenderFns } from "./ShareTalentMatrixUsersTable.vue?vue&type=template&id=96088482&scoped=true"
import script from "./ShareTalentMatrixUsersTable.vue?vue&type=script&lang=js"
export * from "./ShareTalentMatrixUsersTable.vue?vue&type=script&lang=js"
import style0 from "./ShareTalentMatrixUsersTable.vue?vue&type=style&index=0&id=96088482&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96088482",
  null
  
)

export default component.exports